import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  PricePerBodyRequest,
  PricePerBodyResponse,
} from '../models/price-per-body.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PricePerBodyService {
  constructor(private readonly http: HttpClient) {}

  getPricePerBody(
    requestPayload: PricePerBodyRequest
  ): Observable<PricePerBodyResponse> {
    const url = '/price-per-body/get-price-per-body';
    console.log(requestPayload);
    return this.http.post<PricePerBodyResponse>(url, requestPayload);
  }
}
